import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Dropdown } from 'semantic-ui-react'
import { FarmersQuery } from '~/QueryHooks/Farmers'
import Dialog from '~/components/Dialog'
import TableComponent from '~/components/TableComponent'
import i18n from '~/components/i18n'
import { KeyLabelType } from '~/types'
interface Props {
  articleBooking: any
  handleClose: () => void
  farmer: string
  months: KeyLabelType[]
}

const getTableColumnHeaders = () => [
  {
    name: i18n.t('Booking date'),
    type: 'date',
    format: 'DD.MM.YYYY HH:mm',
    key: 'bookingDate'
  },
  {
    name: i18n.t('Article No.'),
    key: 'uniqueId'
  },
  {
    name: i18n.t('Amount'),
    key: 'amount',
    type: 'no-unit-number',
    decimalScale: 0
  },
  {
    name: i18n.t('Article name'),
    key: 'name'
  },
  {
    name: i18n.t('Unit'),
    key: 'unitLabel'
  },
  {
    name: i18n.t('Period'),
    key: 'intervalLabel'
  },
  {
    name: i18n.t('Article price'),
    key: 'netPrice',
    type: 'no-unit-number',
    decimalScale: 5
  },
  {
    name: i18n.t('Tax'),
    key: 'tax',
    type: 'tax-number'
  },
  {
    name: i18n.t('Article price bruto (in €)'),
    key: 'grossPrice',
    type: 'no-unit-number'
  }
]

const ViewDialog:React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { id } = useParams()
  const tableColumnHeaders = getTableColumnHeaders()

  const [dataFiltered, setDataFiltered] = useState({
    rows: 10,
    page: 0,
    month: ''
  })

  const {
    articleBooking,
    handleClose,
    farmer,
    months
  } = props

  const {
    data: articleBookingData,
    isLoading: isLoading,
    isFetching: isFetchingData,
    refetch: fetchArticleBookingData
  } = FarmersQuery.getFarmerArticleBookings(id, articleBooking?.id, dataFiltered)

  useEffect(() => {
    if(articleBooking) {
      fetchArticleBookingData()
    }
  }, [articleBooking, dataFiltered])

  function renderTable() {
    return <TableComponent
      animated
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(dataFiltered) => setDataFiltered(dataFiltered)}
      isFetchingData={isFetchingData}
      tableColumnHeaders={tableColumnHeaders}
      rows={rows}
      total={filtered}
    />
  }

  function renderFilters() {
    return <Dropdown
      style={{ marginBottom: 15 }}
      value={dataFiltered.month}
      clearable
      placeholder={t('Select month')}
      options={months.map((month) => ({ value: month.key, text: month.label }))}
      onChange={(e, data) => setDataFiltered({
        ...dataFiltered,
        //@ts-ignore
        month: data.value
      })}
      selectOnBlur={false}
      selection
    />
  }

  function renderArticleBookings() {
    return <div style={{ minHeight: '30vh' }}>
      {renderFilters()}
      {renderTable()}
    </div>
  }

  const { filtered, rows } = articleBookingData ? articleBookingData : { filtered: 0, rows: [] }

  return <Dialog
    isLoading={isLoading}
    style={{ width: '85%' }}
    textHeader={t('Article booking details for farmer: {{farmer}}', { farmer: farmer })}
    textClose={t('Close')}
    handleClose={() => handleClose()}
    open={Boolean(articleBooking)}
    textContent={renderArticleBookings()}
  />
}
export default ViewDialog